import { render } from "./Vision_working_group_future.vue?vue&type=template&id=7bf8eb78&scoped=true"
import script from "./Vision_working_group_future.vue?vue&type=script&lang=js"
export * from "./Vision_working_group_future.vue?vue&type=script&lang=js"

import "./Vision_working_group_future.vue?vue&type=style&index=0&id=7bf8eb78&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf8eb78"]])

export default __exports__